// extracted by mini-css-extract-plugin
export var date = "NewsPostCard-module--date--d458f";
export var excerpt = "NewsPostCard-module--excerpt--42b46";
export var horizontal = "NewsPostCard-module--horizontal--f6d00";
export var imageContainer = "NewsPostCard-module--image-container--525fe";
export var meta = "NewsPostCard-module--meta--e2088";
export var postCard = "NewsPostCard-module--post-card--51892";
export var readMore = "NewsPostCard-module--read-more--6be47";
export var title = "NewsPostCard-module--title--2b7b3";